define('Independent.Confirmation.View',
[
    'independent_confirmation.tpl',
    'underscore',
    'Backbone'
],
function (independent_confirmation_tpl,
          _,
          Backbone) {

    'use strict';

    return Backbone.View.extend({


        template: independent_confirmation_tpl

        , initialize: function (options) {
        }

        , getContext: function () {
            return {
            };
        }

    })
})
